
export const projs = [ 'otk', 'sert', 'gbo', 'kl', 'ekmt', 'split', 'train', 'sertsgt' ] as const;
export type TProjID = typeof projs[number];

export interface IProj {
    id:TProjID;
    ref:string;
    name:string;
    predefined_name?:string;
    visible?:boolean;
  }

